import React from 'react'
import classnames from 'classnames'
import './Overlay.css'

const Overlay = ({ children, isVisible, ...rest }) => {
  const classes = classnames({
    Overlay: 'true',
    isVisible,
  })
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}

export default Overlay



// WEBPACK FOOTER //
// ./src/components/Overlay.js